import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "intent"];

  submitWithLexical(event) {
    event.preventDefault();
    // どちらのボタンかをhiddenにセット（name属性をintentに）
    if (this.hasIntentTarget) {
      this.intentTarget.value = event.target.name;
    }
    window.dispatchEvent(new Event('lexical:exportAsHTML'));
    setTimeout(() => {
      this.formTarget.submit();
    }, 50);
  }
}
